import React, { ComponentProps } from 'react';
import { UnpaddedLayout } from 'components/Layout';
import PhoneDisplay from 'components/SubLandingPage/Duo/PhoneDisplay';
import PremiumDisplay from 'components/SubLandingPage/Duo/PremiumDisplay';
import StepsDisplay from 'components/SubLandingPage/Duo/StepsDisplay';
import InvitationDisplay from 'components/SubLandingPage/Duo/InvitationDisplay';
import AcceptDisplay from 'components/SubLandingPage/Duo/AcceptDisplay';
import { Footer } from '@spotify-internal/masthead-react';
import styled from 'styled-components';

type SubLandingPageProps = ComponentProps<typeof AcceptDisplay> &
  ComponentProps<typeof InvitationDisplay> & {
    mastheadData: any;
  };

const SubLandingPageLayout = styled(UnpaddedLayout)`
  background: var(--background-base);
`;

const SubLandingPage = (props: SubLandingPageProps) => (
  <>
    <SubLandingPageLayout centered>
      <InvitationDisplay {...props} />
      <PhoneDisplay />
      <PremiumDisplay />
      <StepsDisplay />
      <AcceptDisplay {...props} />
    </SubLandingPageLayout>
    {props.mastheadData && <Footer {...props.mastheadData.footer} />}
  </>
);

export default SubLandingPage;
